import React, { useCallback } from 'react'
import { withRouter, Redirect, useLocation, useHistory } from 'react-router'

import ResetPasswordModal from '../AuthModals/ResetPasswordModal/ResetPasswordModal'
import ForgotPasswordModal from '../AuthModals/ForgotPasswordModal/ForgotPasswordModal'
import LoginModal from '../AuthModals/LoginModal/LoginModal'
import CreateAccountModal from '../AuthModals/CreateAccountModal/CreateAccountModal'
import VerifyEmail from '../VerifyEmail/VerifyEmail'
import Link from '../Link/Link'
import FulfillmentSelectorModal from '../FulfillmentSelectorModal/FulfillmentSelectorModal'
import { MFAVerificationModal } from '../AuthModals/MFAVerificationModal/MFAVerificationModal'

const ModeRouter = withRouter(({ location, history }) => {
  const closeLocation = { ...location, search: null }
  const pushLocation = () => history.push(closeLocation)
  const replaceLocation = () => history.replace(closeLocation)

  const routes = {
    login: <LoginModal onClose={pushLocation} />,
    create: <CreateAccountModal onClose={pushLocation} />,
    forgot: <ForgotPasswordModal onClose={pushLocation} />,
    reset: <ResetPasswordModal onClose={replaceLocation} />,
    verify: <VerifyEmail onClose={pushLocation} />,
    mfa: <MFAVerificationModal onClose={pushLocation} />,
    fulfillment: <FulfillmentSelectorModal onClose={replaceLocation} />
  }

  const search = new URLSearchParams(location.search)
  const mode = search.get('mode')
  return routes[mode] || null
})

const getModeComponent = (Component) => ({ mode, state, ...props }) => {
  const search = new URLSearchParams()
  search.set('mode', mode)
  return <Component {...props} to={{ search: search.toString(), state }} />
}

const ModeRedirect = getModeComponent(Redirect)
const ModeLink = getModeComponent(Link)

export const useHasMode = (value) => {
  const location = useLocation()
  return new URLSearchParams(location.search).get('mode') === value
}

/**
 *
 * @param {Object} useModeHistoryPushCallbackParams
 * @param {string} useModeHistoryPushCallbackParams.mode
 * @param {import('history').LocationDescriptorObject|string} useModeHistoryPushCallbackParams.to - A location object or pathname string (note: replaces search with 'mode' parameter)
 */
export const useModeHistoryPushCallback = ({ mode, to = { pathname: '/' } }) => {
  const history = useHistory()
  const params = new URLSearchParams()
  params.set('mode', mode)

  if (typeof to === 'string') {
    to = { pathname: to }
  }

  return useCallback(() => {
    history.push({
      ...to,
      search: '?' + params.toString()
    })
  }, [history, params, to])
}

export {ModeRouter, ModeRedirect, ModeLink}
